import type { ArbeitsplatzSchrittStatus } from "@/api/purchase";
import { STATUS_TEXTE, statusFarbeKlasse } from "./schritte";

export interface SpurKarteSchritt {
  nr: number;
  kurz: string;
  status: ArbeitsplatzSchrittStatus;
}

interface SpurKarteProps {
  spurKey: string;
  titel: string;
  untertitel: string;
  /** "Jetzt: <Aufgabe>" bzw. "Wartet auf: …" — ohne Zahlen aus dem Geldpfad. */
  jetztLabel: string;
  jetztText: string;
  schritte: SpurKarteSchritt[];
  farbe: string;
  ausgewaehlt: boolean;
  onSelect: (key: string) => void;
}

/** Eine Spur in der linken Leiste: Farbleiste, Titel, "Jetzt:"-Zeile, Mini-Fortschritt. */
export function SpurKarte({ spurKey, titel, untertitel, jetztLabel, jetztText, schritte, farbe, ausgewaehlt, onSelect }: SpurKarteProps) {
  return (
    <button
      type="button"
      aria-pressed={ausgewaehlt}
      aria-label={`Spur ${titel}`}
      onClick={() => onSelect(spurKey)}
      style={{ borderLeftColor: farbe }}
      className={`w-full rounded-md border border-l-4 bg-background px-3 py-2.5 text-left outline-none motion-safe:transition-[box-shadow,border-color] focus-visible:ring-[3px] focus-visible:ring-ring/50 ${
        ausgewaehlt ? "border-primary shadow-[0_0_0_3px_var(--primary-soft)]" : "border-line hover:border-ink-2/60"
      }`}
    >
      <div className="flex items-baseline justify-between gap-2">
        <span className="font-display text-sm font-bold text-ink" style={{ color: farbe }}>{titel}</span>
        <span className="text-[11px] text-ink-2">{untertitel}</span>
      </div>
      <div className="mt-1 mb-2 text-xs text-ink-2">
        {jetztLabel} <span className="font-semibold text-ink">{jetztText}</span>
      </div>
      <ol
        aria-label={`Fortschritt ${titel}`}
        className="grid gap-0.5"
        style={{ gridTemplateColumns: `repeat(${schritte.length}, minmax(0, 1fr))` }}
      >
        {schritte.map((s) => (
          <li
            key={s.nr}
            aria-label={`${s.kurz}: ${STATUS_TEXTE[s.status]}`}
            title={`${s.kurz}: ${STATUS_TEXTE[s.status]}`}
            className={`h-2 rounded-sm ${statusFarbeKlasse(s.status)}`}
          />
        ))}
      </ol>
    </button>
  );
}
